import { PakBomViewMode, PakLocationViewMode } from '../../enums';

export const ModeNamesMappingGA = new Map<PakBomViewMode | PakLocationViewMode, string>([
  [PakBomViewMode.List, 'Table'],
  [PakBomViewMode.Optimizer, 'Optimizer'],
  [PakLocationViewMode.List, 'Table'],
  [PakLocationViewMode.ThreeD, '3D'],
]);
